module.exports = __webpack_public_path__ + "static/images/ventilation-fan.4184a91bf6eedaba2d63677b63448dda.svg";